import Head from "next/head";
import { labels } from "ui/data/constants/labels";
import { AuthProvider } from "@cogitate/diep2-components-core";
import { getStoreState, setStoreState } from "@cogitate/ui-utils-core-test/dist/utilities/pages/shared";
import { fetchActionConfig, fetchQueriesAndFragements, fetchRoleAuthorization, fetchUISchema, setData } from "@cogitate/ui-utils-core-test/dist/utilities/shared/schemafromblob";
import { buttonRouteKeys, policySchemaKeys, routeKeys } from "ui/data/personal/homeowners/constants/keys";
import { staticItems } from "ui/data/personal/homeowners/constants/static";
import { flowKeys, PolicyLogHeader, storeKeys } from "ui/data/constants/keys";
import { useRouter } from "next/router";
import { fetchmenu, fetchvalidation, LoadPolicyDetailsByInsuredEmail } from "ui/utilities/helper";
import { loadRoleScopedUserMasters } from "ui/utilities/agencyAgentUwMasters";
import { toast } from "react-toastify";
import { loadMastersByContainer } from "@cogitate/ui-utils-core-test/dist/utilities/shared/masters";

export default function CustomerPortal() {
  const loggedInUser = getStoreState(storeKeys.LoggedInUserReducer);
  const router = useRouter();

  const onSuccess = async (response) => {
    if (!response || Object.keys(response).length === 0) {
      const searchParams = new URLSearchParams(window.location.search);
      const errorParams = searchParams.get("error");

      // when clicked on cancel button in SSO login page, redirecting back to login page
      if (errorParams === "invalid_authorization_response") {
        window.location.search = "";
      }
      return;
    }

    if (response?.decodedJWT?.role && response?.decodedJWT?.role !== "Insured") {
      router.push(routeKeys.DashboardAccountHub.toLowerCase());
      return;
    }

    setStoreState(storeKeys.LoggedInUserReducer, response);
    await setData({ buttonRouteKeys, routeKeys, staticItems, policySchemaKeys, PolicyLogHeader });

    await Promise.all([
      loadMastersByContainer(),
      fetchQueriesAndFragements(),
      fetchRoleAuthorization(),
      fetchvalidation(),
      fetchActionConfig(),
      fetchmenu(),
      fetchUISchema(
        process.env.NEXT_PUBLIC_CLIENT,
        process.env.NEXT_PUBLIC_DEFAULT_LINE,
        process.env.NEXT_PUBLIC_LINE_OF_BUSINESS,
        process.env.NEXT_PUBLIC_DEFAULT_STATE.toLowerCase(),
        process.env.NEXT_PUBLIC_DEFAULT_CARRIER.toLowerCase(),
        [
          flowKeys.Modals.toLowerCase(),
          flowKeys.AccountHub.toLowerCase(),
        ],
        process.env.NEXT_PUBLIC_DEFAULT_VERSION.toLowerCase()
      )
    ]);

    await loadRoleScopedUserMasters();

    if (response?.decodedJWT?.email) {
      const resp = await LoadPolicyDetailsByInsuredEmail(response.decodedJWT.email);

      if (!resp) {
        toast.error(`No records found. Please enter valid details.`);
      } else if (resp.length === 1) {
        const selectedPolicy = resp[0];

        setStoreState(storeKeys.PolicyReducer, selectedPolicy);
        router.push(routeKeys.ApplicationSummary.toLowerCase());
      } else {
        router.push(routeKeys.DashboardAccountHub.toLowerCase());
      }
        
    }
  }

  return (
    <>
      <Head>
        <title>{labels.Shared.CustomerPortal.PageTitle}</title>
        <meta name="description" content="Developed By Team Cogitate" />
        <link
          rel="icon"
          href={`${process.env.NEXT_PUBLIC_CDN_IMAGE_PATH}/${process.env.NEXT_PUBLIC_AZURE_IMAGE_STYLE_STORAGE_ACCOUNT_NAME}/${process.env.NEXT_PUBLIC_CLIENT}/${process.env.NEXT_PUBLIC_ASSESTS_IMAGES}/favicon-embark.png`}
        />
      </Head>

      <AuthProvider
        AuthUrl={process.env.NEXT_PUBLIC_EMBARK_SSO_URL+ process.env.NEXT_PUBLIC_PROJECT_URL + "/customerportal&redirectSlug=true" }
        UserStore={loggedInUser}
        onSuccess={onSuccess}
      >
      </AuthProvider>
    </>
  )
}


CustomerPortal.layout = "L1";